"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const statusProfiles = {
  on: _BaseTheme.default.colors.green,
  off: _BaseTheme.default.colors.lightgray,
  error: _BaseTheme.default.colors.red,
  alert: _BaseTheme.default.colors.yellow
};

const Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Status__Wrapper",
  componentId: "design-system__sc-1c2ej4h-0"
})(["display:flex;align-items:center;"]);

const StyledStatus = _styledComponents.default.div.withConfig({
  displayName: "Status__StyledStatus",
  componentId: "design-system__sc-1c2ej4h-1"
})(["font-family:'Roboto',sans-serif;font-size:16px;width:0.5rem;height:0.5rem;border-radius:50%;margin:0 1rem;background-color:", ";"], _ref => {
  let {
    status
  } = _ref;
  return statusProfiles[status];
});

const StatusLabel = _styledComponents.default.span.withConfig({
  displayName: "Status__StatusLabel",
  componentId: "design-system__sc-1c2ej4h-2"
})(["font-family:", ";font-size:", ";color:", ";line-height:", ";"], _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.normal, _BaseTheme.default.colors.blue, _BaseTheme.default.type.lineHeight.regular);

const StatusExplanation = _styledComponents.default.span.withConfig({
  displayName: "Status__StatusExplanation",
  componentId: "design-system__sc-1c2ej4h-3"
})(["font-family:", ";font-size:", ";color:", ";padding-left:0.5rem;line-height:", ";"], _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.small, _BaseTheme.default.colors.lightgray, _BaseTheme.default.type.lineHeight.large);

const Status = _ref2 => {
  let {
    status,
    label,
    explanation
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(StyledStatus, {
    status: status
  }), label && /*#__PURE__*/_react.default.createElement(StatusLabel, null, label), explanation && /*#__PURE__*/_react.default.createElement(StatusExplanation, null, explanation));
};

Status.propTypes = {
  status: _propTypes.default.oneOf(['on', 'off', 'error', 'alert']).isRequired,
  label: _propTypes.default.string,
  explanation: _propTypes.default.string
};
Status.defaultProps = {
  label: undefined,
  explanation: undefined
};
var _default = Status;
exports.default = _default;